module.exports = __webpack_public_path__ + "static/media/prestige.964d95e5.png";